import React from "react";
//#region components
import { Grid, Skeleton } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

// Pill-shaped placeholders matching the choice/category chip row (single label)
// while the employee-scoped item set (re)loads. Widths approximate a typical category
// set (e.g. Frånvaro / Arbetad tid / Ersättning); skeletons are intentionally approximate.
const CHIP_PLACEHOLDER_WIDTHS = ["92px", "116px", "104px"];

const ChoiceChipsSkeleton: React.FC = () => (
  <>
    {CHIP_PLACEHOLDER_WIDTHS.map((width, index) => (
      <Grid item key={index} className={cssExports.chipContainer}>
        <Skeleton variant="rounded" width={width} height="28px" className={cssExports.choiceChipSkeleton} />
      </Grid>
    ))}
  </>
);

export default ChoiceChipsSkeleton;
